import styled from "styled-components";

export const DownloadSignedUrlContainer = styled.div`
`
